import _ from 'lodash';
import moment from 'moment';
import TaskService from '../services/TaskService';
import {RRule, rrulestr } from 'rrule';
import { createTaskSorter } from '../utils/taskSorter';
// 20260604 -- Copilot (Claude Sonnet 4.6) -- Added Logger to replace raw console.log calls
import Logger from '@/utils/Logger';

const log = Logger.create('taskOps')

/* No point to this comment except Zack is playing with branches */

export default {
    data() {
        return { 
            taskValidation: {
                valid: true,
                title: null,
            },
            userPrefs: {
                defaultTaskOptions: {}
            },
            dateFields: [
                { name: '', item: null},
                { name: 'Completed', item: 'completedDate'},
                { name: 'Created', item: 'added'},
                { name: 'Due', item: 'due'},
                { name: 'Start', item: 'start'},
            ],
            defaultDateOptions: [
                { name: 'Today', item: '0'},
                { name: 'Tomorrow', item: '1'},
                { name: 'In Two Days (+2)', item: '2'},
                { name: 'In Three Days (+3)', item: '3'},
                { name: 'In One Week (+7)', item: '7'},
                { name: 'In One Month (+30)', item: '30'},
            ],
            emptyTask: {
                "_id": null,
                "id": null,
                "added": null,
                "children": [],
                "completed": null,
                "context": null,
                "due": null,
                "duetime": null,
                "folder": null,
                'length': null,
                "notes": null,
                "owner": null,
                "priority": null,
                "remind": null,
                "remindDate": null,
                "repeat": null,
                "repeatFinal": null,
                "repeatFrom": null,
                "star": null,
                "start": null,
                "starttime": null,
                "status": null,
                "title": null,
                "via": null,
            },
            taskFilter: {
                completed: null,
                context: null,
                dateOneField: null,
                dateOneOp: null,
                dateOneValue: null,
                dateTwoField: null,
                dateTwoOp: null,
                dateTwoValue: null,
                dateThreeField: null,
                dateThreeOp: null,
                dateThreeValue: null,
                folder: null,
                priority: null,
                quickFilter: null,
            },
            taskFilterOps: [
                {name: '<', item: '$lt'},
                {name: '<=', item: '$lte'},
                {name: '>', item: '$gt'},
                {name: '>=', item: '$gte'},
                {name: '=', item: '$eq'},
                {name: '!=', item: '$ne'},
            ],
            taskOrder: { 
                first: null, 
                second: null, 
                third: null,
                firstDirection: 1,
                secondDirection: 1,
                thirdDirection: 1
            },
            defaultTaskOptions: {
                context: null,
                due: null,
                folder: null,
                priority: null,
                start: null,
                status: null,
            },
            quickAddTaskTitle: null,
            quickFilters: [
                { filterString: {
                        completed: 'N',
                        $or: [
                            {
                                folder: ''
                            },
                            {
                                folder: null
                            },
                            {
                                folder: '! Inbox'
                            }
                        ]
                    }
                },
                { filterString: {
                        completed: 'N',                    
                    }
                }],
            quickFilterOptions: [
                { name: 'Use Custom Filter', item:null},
                { name: 'Get Organized', item: 0},
                { name: 'Today\'s Focus', item: 1}
            ],
            resultMessage: '',
            editingField: 'none',
            editingTaskId: 'none',
            originalTask: {},
            previousValue: '',
            previousValueAlt: '',
            validCompletedOptions: [
                { name: 'Completed', item: null, disabled: true},
                { name: 'All', item: 'A'},
                { name: 'No', item: 'N'},
                { name: 'Yes', item: 'Y'}
            ],
            validFilterFields: [
                {
                    label: 'General Fields',
                    options: [
                    { name: 'Complete', item: 'completed'},
                    { name: 'Context', item: 'context'},
                    { name: 'Folder', item: 'folder'},
                    { name: 'Length', item: 'length'},
                    { name: 'Notes', item: 'notes'},
                    { name: 'Priority', item: 'priority'},
                    { name: 'Star', item: 'star'},
                    { name: 'Status', item: 'status'},
                    { name: 'Title', item: 'title'}]
                },
                {
                    label: 'Date Fields',
                    options: [
                    { name: 'Complete', item: 'completedDate'},
                    { name: 'Created', item: 'added'},
                    { name: 'Due', item: 'due'},
                    { name: 'Start', item: 'start'}]
                }
                
            ],
            validPriorities: [
                { name: 'Negative', item: 'negative'},
                { name: 'Low', item: 'low'},
                { name: 'Medium', item: 'medium'},
                { name: 'High', item: 'high'},
                { name: 'Top', item: 'top'},
            ],
            validPriorityRanking: {
                unassigned: -99,
                negative: -1,
                low: 0,
                medium: 1,
                high: 2,
                top: 3
            },
            validReminderFrequencies: [
                { name: 'Never', item: -1},
                { name: '15 minutes', item: 15},
                { name: '30 minutes', item: 30},
                { name: '45 minutes', item: 45},
                { name: '1 hour', item: 60},
                { name: '1.5 hours', item: 90},
                { name: '2 hours', item: 120},
                { name: '3 hours', item: 180},
                { name: '4 hours', item: 240},
                { name: '1 day', item: 1440},
                { name: '2 days', item: 2880},
                { name: '3 days', item: 4320},
                { name: '4 days', item: 5760},
                { name: '5 days', item: 7200},
                { name: '6 days', item: 8640},
                { name: '7 days', item: 10080},
                { name: '14 days', item: 20160},
                { name: '30 days', item: 43200}

            ],
            // Keep synchronized with Task Import
            validRepeatFrequencies: [
                { name: 'None', item: ''},
                { name: 'Advanced', item: 'ADVANCED'},
                { name: 'Daily', item: 'FREQ=DAILY'},
                { name: 'Weekly', item: 'FREQ=WEEKLY'},
                { name: 'Biweekly', item: 'FREQ=WEEKLY;INTERVAL=2'},
                { name: 'Monthly', item: 'FREQ=MONTHLY'},
                { name: 'Bimonthly', item: 'FREQ=MONTHLY;INTERVAL=2'},
                { name: 'Quarterly', item: 'FREQ=MONTHLY;INTERVAL=3'},
                { name: 'Semiannually', item: 'FREQ=MONTHLY;INTERVAL=6'},
                { name: 'Yearly', item: 'FREQ=YEARLY'},
            ],
            validStatuses: [
                { name: "None", item: "none" },
                { name: "Next Action", item: "next" },
                { name: "Active", item: "active"},
                { name: "Planning", item: "planning"},
                { name: "Delegated", item: "delegated"},
                { name: "Waiting", item: "waiting"},
                { name: "Hold", item: "hold"},
                { name: "Postponed", item: "postponed"},
                { name: "Someday", item: "someday"},
                { name: "Canceled", item: "canceled"},
                { name: "Reference", item: "reference"},
            ],
            validTimezones: [],
            sortByOptions: [
                { name: '', item: null},
                { name: 'Context', item: 'context'},
                { name: 'Due', item: 'due'},
                { name: 'Length', item: 'length'},
                { name: 'Folder', item: 'folder'},
                { name: 'Priority', item: 'priority'},
                { name: 'Stack Rank', item: 'stackRank'},
                { name: 'Star', item: 'star'},
                { name: 'Start', item: 'start'},
                { name: 'Status', item: 'status'},
                { name: 'Title', item: 'title'}
            ]
        }
    },
    computed: {
        addedDate: {
            
            // 20200408 -- ZWS -- Bi-directional translation of a task's
            // added [date].  Generally used for display.
            
            get() {
                return TaskService.getStringFromMillis(this.task.added, 'MM/DD/YYYY')
            },
            set(value) {
                this.task.added = TaskService.getMillisFromString(value)
            }
        }, remind: {
            
            // 20200318 -- ZWS -- Translates a task's reminder value into 
            // human-readable text.
            
            get() {
                
                let retVal = ''
                let retValPeriod = ''
                
                if(typeof this.task.remind != 'undefined' && !(this.task.remind === null) && this.task.remind > 0) {    
                    
                    if(this.task.remind < 60) {
                        retVal = this.task.remind
                        retValPeriod = " minute"
                    } else if(this.task.remind < 1440) {
                        retVal = this.task.remind/60
                        retValPeriod = " hour"
                    } else {
                        retVal = this.task.remind/(60*24)
                        retValPeriod = " day"
                    }
                    
                    if(retVal > 1) {
                        retVal += retValPeriod + 's'
                    }

                    // if(retVal % 1 > 0) {
                    //     retVal += retValPeriod + ' (s)'
                    // } else {
                    //     retVal += retValPeriod
                    // }

                } else {
                    retVal = 'n/a';
                }

                return retVal;
            }
        },
        remindDate: {
            
            // 20200318 -- ZWS -- Bi-directional translation of a task's
            // start [time].  Generally used for display.
            
            get() {
                return TaskService.getStringFromMillis(this.task.remindDate, 'MM/DD/YYYY hh:mm a')
            },
            set(value) {
                this.task.remindDate = TaskService.getMillisFromString(value)
            }
        },
        repeat: {
            
            // 20200318 -- ZWS -- Translates a task's repeat value into 
            // human-readable text.
            
            get() {
                
                if(!(typeof this.task.repeat == 'undefined') && !(this.task.repeat === null) && this.task.repeat.length > 0) {
                    
                    let repeatString = this.task.repeat
                    
                    if(repeatString == 'ADVANCED')
                    {
                        repeatString = this.task.repeatFinal
                    }

                    try {
                        if(repeatString.length > 0) {
                            
                            // @TODO Handle repeat = PARENT
                            if(repeatString != 'PARENT') {
                                try {
                                    let repeatFreq = rrulestr(repeatString)
                                    return repeatFreq.toText()
                                } catch(e) {
                                    //////console.log(e + ' in {' + repeatString + '} for ' + this.task.title)
                                    return repeatString
                                }
                            }
                        }
                    } catch(e) {
                        //////console.log('Error parsing repeat: ' + e)
                    }
                    
                    
                    
                } else {
                    return ''
                }
                
                
                // let x = validRepeatFrequencies.findIndex(this.task.repeat) 
                // return validRepeatFrequencies[x].name
            }   
        },
        repeatFinal: {
            
            // 20200318 -- ZWS -- Translates a task's repeat value into 
            // human-readable text.  Only applies to "advanced"
            
            get: function() {
                
                if(typeof this.task.repeatFinal != 'undefined' && !(this.task.repeatFinal === null) && this.task.repeatFinal.length > 0) {
                    
                    try {
                        let repeatFreq = RRule.fromString((this.task.repeatFinal ?? ""))
                        return repeatFreq.toText()   
                    } catch(e) {
                        ////console.log('taskOps.repeatFinal.get encountered an error ("' + e + '") for value = "' + this.task.repeatFinal + '"')
                    }
                    
                     
                } else {
                    return ''
                }
                
                
            },
            set: function(newVal) {
                
                if(typeof newVal != 'undefined' && newVal !== null && newVal.length > 0) {
                    
                    try {
                        // Create an RRule from the user's input 
                        // (e.g. every week on Friday)
                        let repeatFreq = RRule.fromText(newVal)
                        
                        // Get and store the frequency string 
                        // (e.g. INTERVAL=2;FREQ=WEEKLY;BYDAY=FR)
                        this.task.repeatFinal = repeatFreq.toString()   
                    
                    } catch(e) {
                        ////console.log('taskOps.repeatFinal.set encountered an error ("' + e + '") for value = "' + newVal + '"')
                    }
                    
                     
                }

            }
        },
        startDate: {
            
            // 20200318 -- ZWS -- Bi-directional translation of a task's
            // start [date].  Generally used for display.
            
            get() {
                return TaskService.getStringFromMillis(this.task.start, 'MM/DD/YYYY')
            },
            set(value) {
                this.task.start = TaskService.getMillisFromString(value)
            }
        },
        startTime: {
            
            // 20200318 -- ZWS -- Bi-directional translation of a task's
            // start [time].  Generally used for display.
            
            get() {
                return TaskService.getStringFromMillis(this.task.starttime, 'hh:mm a')
            },
            set(value) {
                this.task.starttime = TaskService.getMillisFromString(value)
            }
        },
        dueDate: {
            
            // 20200318 -- ZWS -- Bi-directional translation of a task's
            // due [date].  Generally used for display.
            
            get() {
                return TaskService.getStringFromMillis(this.task.due, 'MM/DD/YYYY')
            },
            set(value) {
                this.task.due = TaskService.getMillisFromString(value)
            }
        },
        dueTime: {
            
            // 20200318 -- ZWS -- Bi-directional translation of a task's
            // due [time].  Generally used for display.
            
            get() {
                return TaskService.getStringFromMillis(this.task.duetime, 'hh:mm a')
            },
            set(value) {
                this.task.duetime = TaskService.getMillisFromString(value)
            }
        },
        startDateForSystem: {
            
            // 20200318 -- ZWS -- Bi-directional translation of a task's
            // start [date].  Generally used for input fields.
            
            get() {
                return TaskService.getStringFromMillis(this.task.start, 'YYYY-MM-DD')
            },
            set(value) {
                if(value != null) {
                    this.task.start = TaskService.getMillisFromString(value)
                } else {
                    //////console.log('startDateForSystem - computed setter - nothing to set')
                }
            }
        },
        startTimeForSystem: {
            
            // 20200318 -- ZWS -- Bi-directional translation of a task's
            // start [time].  Generally used for input fields.
            
            get() {
                return TaskService.getStringFromMillis(this.task.starttime, 'kk:mm')
            },
            set(value) {
                this.task.starttime = TaskService.getMillisFromString(value, false, 'kk:mm')   
            }
        },
        dueDateForSystem: {
            
            // 20200318 -- ZWS -- Bi-directional translation of a task's
            // due [date].  Generally used for input fields.
            
            get() {
                return TaskService.getStringFromMillis(this.task.due, 'YYYY-MM-DD')
            },
            set(value) {
                this.task.due = TaskService.getMillisFromString(value)
            }
        },
        dueTimeForSystem: {
            
            // 20200318 -- ZWS -- Bi-directional translation of a task's
            // due [time].  Generally used for input fields.
            
            get() {
                return TaskService.getStringFromMillis(this.task.duetime, 'kk:mm')
            },
            set(value) {
                this.task.duetime = TaskService.getMillisFromString(value, false, 'kk:mm')     
            }
        },
    },
    methods: {
        
        cancelTaskEditMode() {
            
            // 20200318 -- ZWS -- Invoked when the user chooses to cancel
            // editing a task.
            
            this.localTask = this.originalTask

            this.editingTaskId = 'none'
            this.taskValidation = {}
            this.taskValidation.valid = true
        },
        enterTaskEditMode(taskId) {
            
            // 20200318 -- ZWS -- Invoked when a user desires to edit a task.

            if(this.editingTaskId == 'none') {
                let _= require('lodash');
                this.originalTask = _.cloneDeep(this.task);
            } else {
                this.cancelTaskEditMode()
            }

            this.editingTaskId = taskId
            this.hideDetail = true
            
            
        },
        addTask(taskObj, defaults) {

            ////console.log('taskOps.addTask()')

            this.task = Object.assign({}, this.emptyTask)

            if(typeof defaults !== 'undefined' && defaults !== null) {
                if(typeof defaults.field !== 'undefined' && defaults.field !== null) {
                    this.task[defaults.field] = defaults.value
                }
            }

            this.$bvModal.show('taskModal')
        },
        filterTasks() {
            
            // 20200318 -- ZWS -- Invoked when the user desires to define a
            // a task filter using the pop-up.

            this.$bvModal.show('taskFilterPopupModal')
        },
        timeForSystemSetter(dateFieldName, timeFieldName, newValue) {
            
            // 20200318 -- ZWS -- Common method for the computed properties to
            // use when translating a string value from an input field to
            // milliseconds for storage in the task object.
            // 20201003 -- ZWS -- Retired.  Replace logic with something later in the process
            // to better guarantee that the time aligns with the date.
            
            if(!(typeof newValue == 'undefined') && !(newValue === null)) {
                    
                // 20200419 -- ZWS -- Length of newValue must be greater than
                // zero otherwise, assume that the time should be blank/empty. 
                if(newValue.length > 0){

                    let dateString = null

                    if(this.task[dateFieldName] != null && this.task[dateFieldName] > 0) {
                        dateString = TaskService.getStringFromMillis(this.task[dateFieldName], 'YYYY-MM-DD')    
                    } else {
                        dateString = TaskService.getStringFromMillis(0, 'YYYY-MM-DD')    
                    }

                    this.task[timeFieldName] = TaskService.getMillisFromString(dateString + ' ' + newValue, false, 'YYYY-MM-DD HH:mm')

                } else {

                    this.task[timeFieldName] = null

                }
                
                

            } else {
                this.task[timeFieldName] = null
            }
        },
        async toggleTaskFlag(field) {

            // 20200318 -- ZWS -- Common method for toggling a 
            // flag (i.e. a Y or N value).  Includes special logic to handle
            // when a repeating task is marked complete.
            //
            // Emits: message:task
            
            let temp = this.task[field]

            if(temp == 'Y') {
                temp = 'N'
            } else {
                temp = 'Y'
            }

            this.task[field] = temp;

            if(field == 'completed' && temp == 'Y') {

                this.task.completedDate = Number(moment().format('x'))
                this.task.status = 'none'
                
                if(typeof this.task.repeat != 'undefined' && !(this.task.repeat === null) && this.task.repeat.length > 0) {

                    // @TODO Investigate merging this into TaskService.setSystemValues
                    /* eslint-disable no-undef */
                    let newTask = $.extend(true, {}, this.task)
                    /* eslint-enable no-undef */
                    
                    TaskService.setSystemValues(newTask)
                    
                    newTask.createdFrom = this.task._id
                    newTask._id = null
                    newTask.completed = 'N'
                    newTask.completedDate = null;
                    newTask.remindSent = 'N'  
                    newTask.remindDate = null

                    // 20260127 -- Copilot (Claude Sonnet 4.5) -- Get repeatFrom from original task
                    // WHY: newTask is a copy, so repeatFrom should exist on it already
                    let repeatFromField = newTask.repeatFrom

                    if(typeof repeatFromField == 'undefined' || repeatFromField === null || repeatFromField.length <= 0) {
                        repeatFromField = 'due'
                    }
                    
                    // 20260127 -- Copilot (Claude Sonnet 4.5) -- Use time field instead of date-only field if available
                    // WHY: 'due' field stores date at midnight, 'duetime' has the actual time
                    // NOTE: completedDate already includes time, but check duetime as fallback if completedDate is at midnight
                    let repeatFromValue = this.task[repeatFromField]
                    if(repeatFromField === 'due' && this.task.duetime > 0) {
                        repeatFromValue = this.task.duetime
                        // 20260127 -- Copilot (Claude Sonnet 4.5) -- If due is in the past, use completedDate instead
                        // WHY: Can't repeat from a past due date, use actual completion time
                        let now = Number(moment().format('x'))
                        if(repeatFromValue < now) {
                            repeatFromValue = this.task.completedDate
                            repeatFromField = 'completedDate' // Update for logging purposes
                        }
                    } else if(repeatFromField === 'completedDate' && this.task.duetime > 0) {
                        // If completedDate exists but appears to be at midnight, prefer duetime
                        let completedMoment = moment(repeatFromValue)
                        if(completedMoment.hours() === 0 && completedMoment.minutes() === 0 && completedMoment.seconds() === 0) {
                            repeatFromValue = this.task.duetime
                        }
                    }
                    
                    log.debug('Repeat: repeatFromField=' + repeatFromField + ', original value=' + repeatFromValue + ' (' + moment(repeatFromValue).format('DD-MMM HH:mm') + ')')

                    try {
                    
                        let rule = null
                        
                        let repeatRule = newTask.repeatFinal

                        if(typeof repeatRule == 'undefined' || repeatRule === null) {
                            
                            repeatRule = newTask.repeat

                            // 20200420 -- ZWS -- Make sure there is a repeat
                            // rule specified.  Otherwise, this is an error.
                            if(typeof repeatRule == 'undefined' || repeatRule === null || repeatRule == 'ADVANCED') {

                                rule = null

                            } else {
                                
                                // 20200419 -- ZWS -- Only set interval for
                                // non-advanced rules
                                if(repeatRule.indexOf(';INTERVAL') < 0) {
                                    repeatRule += ";INTERVAL=1"
                                }

                                ////console.log('Creating rule from repeat = ' + repeatRule)
                                rule = RRule.fromString(repeatRule)
                                ////console.log('Created rule from: ' + repeatRule)
                            
                            }

                            
                            

                        } else {

                            // let ruleOptions = RRule.parseString(repeatRule)
                            // 20200419 -- ZWS -- Works for Advanced
                            ////console.log('Creating rule from repeatFinal = ' + repeatRule)
                            rule = RRule.fromString(repeatRule)
                            ////console.log('Created rule from: ' + repeatRule)

                        }

                        
                        if(rule !== null) {

                            // ////console.log('repeatFromField = ' + repeatFromField)
                            // ////console.log('this.task[repeatFromField] = ' + this.task[repeatFromField])


                            let repeatFrom = new Date(repeatFromValue)
                            
                            // ////console.log('repeatFrom = ' + repeatFrom)
                            
                            ////console.log('repeatRule = ' + repeatRule)

                            // 20260127 -- Copilot (Claude Sonnet 4.5) -- Create new rule with dtstart
                            // WHY: Setting dtstart after creating rule doesn't work properly
                            let ruleOptions = RRule.parseString(rule.toString())
                            ruleOptions.dtstart = repeatFrom
                            let ruleWithStart = new RRule(ruleOptions)
                            
                            // 20260127 -- Copilot (Claude Sonnet 4.5) -- Get next occurrence strictly after repeatFrom
                            // WHY: Add 1 second to ensure we get the NEXT occurrence, not the current one
                            let searchDate = new Date(repeatFrom.getTime() + 1000)
                            let nextDue = ruleWithStart.after(searchDate, false)
                            
                            console.log('Repeat: repeatFrom=' + repeatFrom + ', nextDue=' + nextDue + ', repeatRule=' + repeatRule)

                            // 20260127 -- Copilot (Claude Sonnet 4.5) -- Calculate date offset for repeating tasks
                            // WHY: Update date fields (start, due) when creating repeated task
                            // UPDATED: 20260127 -- Use repeatFromValue instead of this.task[repeatFromField] for correct offset
                            let dueDif = Number(moment(nextDue).format('x')) - repeatFromValue
                            
                            console.log('Repeat: dueDif=' + dueDif + ' ms (' + (dueDif / 86400000) + ' days)')
                            
                            console.log('Repeat BEFORE: start=' + this.task.start + ' (' + moment(this.task.start).format('DD-MMM HH:mm') + '), starttime=' + this.task.starttime + ' (' + moment(this.task.starttime).format('DD-MMM HH:mm') + '), due=' + this.task.due + ' (' + moment(this.task.due).format('DD-MMM HH:mm') + '), duetime=' + this.task.duetime + ' (' + moment(this.task.duetime).format('DD-MMM HH:mm') + ')')
                            
                            // 20260127 -- Copilot (Claude Sonnet 4.5) -- Calculate duration between start and due DATES
                            // WHY: Preserve the date window for the task (start/due are always at midnight)
                            // NOTE: start/due are dates at midnight; starttime/duetime have the actual times
                            let startDueDateDuration = 0
                            if(this.task.due > 0 && this.task.start > 0) {
                                startDueDateDuration = this.task.due - this.task.start
                            }
                            
                            console.log('Repeat: startDueDateDuration=' + startDueDateDuration + ' ms (' + (startDueDateDuration / 86400000) + ' days)')
                            
                            // 20260127 -- Copilot (Claude Sonnet 4.5) -- When repeating from due (not in past):
                            // New Start = Original Due + Frequency, New Due = New Start + Duration
                            if(repeatFromField === 'due') {
                                // New Start = Original Due + Frequency
                                newTask.start = Number(moment(nextDue).startOf('day').format('x'))
                                
                                // New Due = New Start + Duration
                                newTask.due = newTask.start + startDueDateDuration
                            } else {
                                // When repeating from completed: New Due = nextDue, New Start = New Due - Duration
                                newTask.due = Number(moment(nextDue).startOf('day').format('x'))
                                newTask.start = newTask.due - startDueDateDuration
                            }
                            
                            // Set duetime preserving the original time-of-day
                            if(this.task.duetime > 0) {
                                // 20260604 -- Copilot (Claude Sonnet 4.6) -- Omit ZZ to use target date's DST offset (mirrors calculateDynamicFields fix)
                                let timeString = TaskService.getStringFromMillis(this.task.duetime, 'HH:mm a')
                                let dateString = TaskService.getStringFromMillis(newTask.due, 'MM/DD/YYYY')
                                newTask.duetime = TaskService.getMillisFromString(dateString + ' ' + timeString, false, 'MM/DD/YYYY HH:mm a')
                            }

                            // Set starttime preserving the original time-of-day
                            if(newTask.starttime > 0 && this.task.starttime > 0) {
                                // 20260604 -- Copilot (Claude Sonnet 4.6) -- Omit ZZ to use target date's DST offset (mirrors calculateDynamicFields fix)
                                let timeString = TaskService.getStringFromMillis(this.task.starttime, 'HH:mm a')
                                let dateString = TaskService.getStringFromMillis(newTask.start, 'MM/DD/YYYY')
                                newTask.starttime = TaskService.getMillisFromString(dateString + ' ' + timeString, false, 'MM/DD/YYYY HH:mm a')
                            }
                            
                            log.debug('Repeat: repeatFromField=' + repeatFromField + ', new start=' + newTask.start + ' (' + moment(newTask.start).format('DD-MMM HH:mm') + '), new due=' + newTask.due + ' (' + moment(newTask.due).format('DD-MMM HH:mm') + ')')
                            log.debug('Repeat AFTER (before calculateDynamicFields): start=' + newTask.start + ' (' + moment(newTask.start).format('DD-MMM HH:mm') + '), starttime=' + newTask.starttime + ' (' + moment(newTask.starttime).format('DD-MMM HH:mm') + '), due=' + newTask.due + ' (' + moment(newTask.due).format('DD-MMM HH:mm') + '), duetime=' + newTask.duetime + ' (' + moment(newTask.duetime).format('DD-MMM HH:mm') + ')')
                            
                            TaskService.calculateDynamicFields(newTask)
                            
                            log.debug('Repeat AFTER (after calculateDynamicFields): start=' + newTask.start + ' (' + moment(newTask.start).format('DD-MMM HH:mm') + '), starttime=' + newTask.starttime + ' (' + moment(newTask.starttime).format('DD-MMM HH:mm') + '), due=' + newTask.due + ' (' + moment(newTask.due).format('DD-MMM HH:mm') + '), duetime=' + newTask.duetime + ' (' + moment(newTask.duetime).format('DD-MMM HH:mm') + ')')

                            // @TODO 20200321 -- ZWS -- Shouldn't this go through
                            // the store?
                            TaskService.addTask(newTask, this.$store.getters.getUserToken)
                        } else {

                            this.$emit('message:task', true, 'Task Edit', 'Unable to create a new instance this recurring task because no repeat frequency was specified.', 'warning')
                          

                        }


                    } catch(e) {
                        this.task.completedDate = null;
                        this.task.completed = 'N'
                        this.$emit('message:task', true, 'Task Edit', 'Unable to create a new instance this recurring task: ' + e, 'warning')
                        console.log(e)
                        return
                    }

                }
                
                

            } else if(field == 'completed' && temp == 'N') {
                this.task.completedDate = null;
            }

            TaskService.calculateDynamicFields(this.task)

            let rm = await TaskService.updateTask(this.task, this.$store.getters.getUserToken)
            this.$emit('message:task', true, 'Task Edit', rm.data.message, 'success')

        },
        // 20200318 -- ZWS -- Deprecated.  Legacy way of editing a task.  As of
        // this comment it is only used by DateTime.vue (which I believe should
        // be deleted.)
        /*
        async updateTaskField(field) {

            let previousValue = ''
            let currentValue = ''
            

            previousValue = this.previousValue
            currentValue = this.task[this.editingField]
            
            //////console.log(field + ' was ' + this.previousValue + ' now ' + this.task[this.editingField])

            this.editingField = 'none'
            this.previousValue = ''
            this.previousValueAlt = ''

            if(field == 'startDateTime' || field == 'endDateTime' || previousValue != currentValue) {
                
                let rm = ''

                //////console.log('Calling updateTask for ' + field)
                await TaskService.updateTask(this.task, this.$store.getters.getUserToken).then(function(response) {

                    //////console.log('server has response = ' + JSON.stringify(response))
                    rm = response

                }).catch((error) => {
                
                    this.$emit('message:task', true, 'Task Edit', 'Change not saved: ' + error, 'warning')    
                    return
                })

                this.$emit('message:task', true, 'Task Edit', rm, 'success')

            }

            
        },
        */
        async quickAddTask() {
            
            // 20200318 -- ZWS -- Invoked when the user creates a task using
            // the "Quick Add" button.
            
            // let newTask = {}
            this.task = {}
            
            this.task.title = this.quickAddTaskTitle
            this.task.star = 'N'
            this.task.completed = 'N'
            
            this.quickAddTaskTitle = ''

            TaskService.setUserValues(this.task, this.$store.getters.getUserPrefs.defaultTaskOptions)

            this.saveTask()

            // 20200404 -- ZWS -- Clear out quick add task so that it doesn't
            // interfere with other changes.
            this.task = {}
            
            /*
            TaskService.setUserValues(newTask, this.$store.getters.getUserPrefs.defaultTaskOptions)
            TaskService.setSystemValues(newTask)

            this.quickAddTaskTitle = ''
            
            let rm = await TaskService.addTask(newTask, this.$store.getters.getUserToken)
            
            this.resultMessage = rm.data.response.message

            newTask = rm.data.response.data

            // 20191215 -- Manually calling functions (instead of using events) because, apparently,
            // b-button doesn't call non-native events.
            // this.$emit('saved:task', newTask, this.resultMessage)
            // this.$emit('message:task', true, 'Create Task', this.resultMessage, 'success')
            if(rm.data.response.successful) {
                this.makeToast(true, 'Create Task', this.resultMessage, 'success')
                this.saveComplete(newTask, this.resultMessage)
            } else {
                this.makeToast(true, 'Create Task', this.resultMessage, 'warning')
            }
            */
            
            
        },
        async saveTaskEdit() {
            
            this.saveTaskEdit2(this.task)

        },
        async saveTaskEdit2(updatedTask) {
            
            // 20200319 -- ZWS -- Invoked when a user desires to save the changes made
            // while in the mode entered by enterTaskEditMode.
            //
            // Emits: message:task

            
            let rm = ''
            TaskService.calculateDynamicFields(updatedTask)
            await TaskService.updateTask(updatedTask, this.$store.getters.getUserToken).then(function(response) {

                //////console.log('server has response = ' + JSON.stringify(response))
                rm = response

            }).catch((error) => {
            
                this.$emit('message:task', true, 'Task Edit', 'Change not saved: ' + error, 'warning')    
                return
            })

            this.$emit('message:task', true, 'Task Edit', rm.data.message, 'success')

            this.editingTaskId = 'none'
            this.originalTask = {}

        },
        async saveTask() {
            this.saveTask2(this.taskValidation, this.task, true)
        },
        // 20260126 -- Copilot (Claude Sonnet 4.5) -- Added autoCloseModal parameter
        // WHY: Prevent automatic modal close for "Add & Create Similar" workflow
        async saveTask2(taskValidation, task, autoCloseModal = true) {
            
            // 20200319 -- ZWS -- Invoked when a user desires to save a new
            // task or edits to an existing one.  Performs validation in
            // either case.  
            // 
            // saveTaskEdit is called to save changes to an existing task.
            //
            // Emits: createdChild:task, saved:task

            // 20201205 -- ZWS -- This seems to be creating a new object thus making so
            // the invoking method could reference the changes made here.
            // E.g. setting valid = false here couldn't be seen by the invoking method.
            // taskValidation = {}

            this.$set(taskValidation, 'title', null)
            this.$set(taskValidation, 'valid', true)

            if(typeof task.title == 'undefined' || task.title === null || task.title == '') {
                
                taskValidation.title = false
                taskValidation.valid = false
                
            }

            if(taskValidation.valid) {
            
                if(task._id === null || (typeof task._id == 'undefined')) {
                    
                    ////console.log('taskOps.saveChange - task = ' + JSON.stringify(this.task))
                    console.log('taskOps.saveTask2 - task.parent =', task.parent)
                    console.log('taskOps.saveTask2 - task =', task)
                    
                    let _= require('lodash'); 
                    let newTask = _.cloneDeep(task);
                    console.log('taskOps.saveTask2 - newTask.parent after cloneDeep =', newTask.parent)
                    TaskService.setSystemValues(newTask)
                    newTask.completed = 'N'    

                    TaskService.calculateDynamicFields(newTask)
                    
                    let rm = await TaskService.addTask(newTask, this.$store.getters.getUserToken)
                    
                    this.resultMessage = rm.data.response.message

                    ////console.log('taskOps.saveChange - Response from TaskService = ' + JSON.stringify(rm))

                    if(rm.data.response.successful) {
                        
                        newTask = rm.data.response.data[0]

                        ////console.log('taskOps.saveTask has final task = ' + JSON.stringify(newTask))

                        // 20200408 -- ZWS -- New event emission
                        this.$emit('createdChild:task', newTask, this.resultMessage)
                        
                        // 20200321 -- ZWS -- No longer emitting events because
                        // this function may not be invoked from a object that
                        // has registered listeners.
                        //this.$emit('saved:task', newTask, this.resultMessage)
                        //this.$emit('message:task', true, 'Create Task', this.resultMessage, 'success')

                        this.saveComplete(newTask, this.resultMessage)
                        this.makeToast(true, 'Create Task', this.resultMessage, 'success')



                    } else {
                        //this.$emit('message:task', true, 'Create Task', this.resultMessage, 'warning')
                        this.makeToast(true, 'Create Task', this.resultMessage, 'success')
                    }

                    
                    
                    // 20260126 -- Copilot (Claude Sonnet 4.5) -- Only hide modal if autoCloseModal is true
                    // WHY: Support "Add & Create Similar" keeping modal open
                    if (autoCloseModal) {
                        // Hide the modal manually
                        try {
                            this.$nextTick(() => {
                                this.$bvModal.hide('taskModal')
                            })
                        } catch(error) {
                            // Intentionally left blank.
                            // Modal may not exist on the UI.
                        }
                    }
                    

                } else {
                    
                    ////console.log('taskOps.saveTask is calling saveTaskEdit')
                    this.saveTaskEdit2(task)

                }
            
            } else {
                
                console.log('Error: ' + JSON.stringify(taskValidation))

                return
            }

            
        },
        sortTasks() {
            
            // 20200318 -- ZWS -- Invoked when the user desires to sort tasks
            // using the pop-up.
            
            this.$bvModal.show('taskSortPopupModal')
        },
        applyFilter(filter, offset) {

            // 20200319 -- ZWS -- Applies a given filter to the tasks already
            // in the store.
            //
            // Dispatches (store): setTaskFilter

            // console.log('taskOps.applyFilter has filter = ')
            // console.log(filter)

            TaskService.refineTaskFilter(filter, this.quickFilters, offset)

            this.$store.dispatch('setTaskFilter', filter)
 
            
        },
        applySort(sortOrder) {
            
            // 20200319 -- ZWS -- Applies a given sort to the tasks already
            // in the store.
            // 
            // @TODO 20200319 -- Logic is hokey.
            // 
            // Dispatches (store): setUserLoading, setSortOrder, setTasks, 
            // setUserLoading
            
            this.$store.dispatch('setUserLoading', true)

            let tempTasks = this.$store.getters.getTasks

            tempTasks.sort(createTaskSorter(sortOrder.first, sortOrder.second, sortOrder.third, sortOrder.firstDirection, sortOrder.secondDirection, sortOrder.thirdDirection));

            this.$store.dispatch('setTaskSortOrder', sortOrder)

            this.$store.dispatch('setTasks', tempTasks)

            this.$store.dispatch('setUserLoading', false)

            this.awaitingSearch = false
        },
        customSort(first, second, third, firstDirection, secondDirection, thirdDirection) {
            // 20200319 -- ZWS -- Custom sort function for arrays of tasks.
            // Refactored to use consolidated taskSorter utility for better type-safety and priority handling
            return createTaskSorter(first, second, third, firstDirection, secondDirection, thirdDirection);
        },
        // 
        // Custom Event Handlers
        //
        async deleteTask(id) {
            
            // 20200319 -- ZWS -- Generic handled for the delete:task event.
            //
            // Dispatches (store): deleteTask

            this.task = null
            
            // 20260129 -- Copilot (Claude Sonnet 4.5) -- Await delete and ensure UI updates
            // WHY: User needs to see task removed from list immediately
            try {
                await this.$store.dispatch('deleteTask', id)
                
                // 20260129 -- Copilot (Claude Sonnet 4.5) -- Wait for next tick to ensure Vue updates DOM
                // WHY: Ensures reactivity has processed the state change before showing toast
                await this.$nextTick()
                
                this.makeToast(true, 'Success', 'Task deleted successfully', 'success')
            } catch (error) {
                this.makeToast(true, 'Error', 'Failed to delete task', 'danger')
            }
            
        },
        saveComplete(newTask, message) {

            // 20200319 -- ZWS -- Generic handler for the saved:task event.
            //
            // Emits: saved:task
            // Dispatches (store): addTask

            this.message = message
            
            var payload = {}
            payload.task = newTask
            
            ////console.log('taskOps.saveComplete has task = ' + JSON.stringify(newTask))

            this.$store.dispatch('addTask', payload)

            this.dismissCountDown = this.dismissSecs
        },
    }
  };